function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { motion, AnimatePresence } from 'framer-motion';
import cn from 'classnames';
import X from 'svg/x.svg';
import AlertsBus from 'modules/App/components/AlertsBus';
var _React_PureComponent;
/**
 * Modal component
 *
 * @param {string} modalId - modal unique id
 * @param {string} openModalId - current open modal unique id
 * @param {string='sm','md','lg','xl} styleModifier - modal width modifier
 * @param {Element} children - modal content
 * @param {number} isInProgress - operations in progress indicator
 * @param {boolean} isDisabled - actions disabling
 * @param {function} onClose - function that is triggered if modal is being closed without confirm
 * @param {string} headerCustomClass - custom className for header
 */ class Modal extends (_React_PureComponent = React.PureComponent) {
    onClose(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (!this.props.onClose || this.props.isInProgress || this.props.isDisabled) {
            return;
        }
        this.props.onClose();
    }
    get isOpen() {
        return this.props.openModalId === this.props.modalId;
    }
    renderCloseBtn() {
        if (!this.props.onClose) {
            return /*#__PURE__*/ _jsx("div", {
                className: "modal__close"
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "modal__close",
            children: /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: "modal__close__btn",
                onClick: (evt)=>this.onClose(evt),
                children: /*#__PURE__*/ _jsx("span", {
                    className: "btn-inner",
                    children: /*#__PURE__*/ _jsx(X, {
                        className: "modal__close__btn__icon"
                    })
                })
            })
        });
    }
    renderHeader() {
        if (!this.props.headerMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: cn('modal__header brand__h1', this.props.headerCustomClass),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, this.props.headerMessage))
                }),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-4"
                })
            ]
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsx("div", {
            className: cn('modal__contentWrapper', {
                'mt-5': !this.props.onClose
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: `modal__content ${this.props.contentCustomClass}`,
                children: [
                    this.renderHeader(),
                    this.props.children
                ]
            })
        });
    }
    renderModal() {
        if (!this.isOpen) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(motion.div, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: cn('modal', {
                [`modal--${this.props.styleModifier}`]: this.props.styleModifier
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "body-overlay",
                    role: "presentation",
                    onClick: (evt)=>this.onClose(evt)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "modal__container",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "modal__body",
                        children: [
                            this.renderCloseBtn(),
                            this.renderContent()
                        ]
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(AnimatePresence, {
            children: this.renderModal()
        });
    }
}
_define_property(Modal, "propTypes", {
    // Explicit props
    modalId: PropTypes.string.isRequired,
    openModalId: PropTypes.string,
    styleModifier: PropTypes.oneOf([
        'sm',
        'md',
        'lg',
        'xl'
    ]),
    headerCustomClass: PropTypes.string,
    contentCustomClass: PropTypes.string,
    headerMessage: PropTypes.object,
    children: PropTypes.node,
    isInProgress: PropTypes.bool,
    isDisabled: PropTypes.bool,
    // Explicit actions
    onClose: PropTypes.func
});
_define_property(Modal, "defaultProps", {
    isInProgress: false,
    isDisabled: false
});
export default Modal;
